import React, { useEffect, useState } from 'react';
import { Routes, Route, NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Users as UsersIcon, Server, GitBranch, AlertTriangle,
  KeyRound, LogOut, UserCircle2, Menu, ChevronsLeft, ChevronsRight,
  // Receipt,   // PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19)
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import NotificationBell from '../components/NotificationBell';
import LiveDot from '../components/LiveDot';
import Overview from '../views/admin/Overview';
import Users from '../views/admin/Users';
import Containers from '../views/admin/Containers';
import CopyRelationships from '../views/admin/CopyRelationships';
import Errors from '../views/admin/Errors';
import Partners from '../views/admin/Partners';
// PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19)
// import AdminBilling from '../views/admin/Billing';

const NAV = [
  { to: '/admin',               end: true,  icon: LayoutDashboard, label: 'Overview' },
  { to: '/admin/users',         icon: UsersIcon,                   label: 'Users' },
  { to: '/admin/containers',    icon: Server,                      label: 'Containers' },
  { to: '/admin/errors',        icon: AlertTriangle,               label: 'Errors' },
  { to: '/admin/relationships', icon: GitBranch,                   label: 'Copy Relationships' },
  { to: '/admin/partners',      icon: KeyRound,                    label: 'Partner API' },
  // PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19); see worker.js
  // { to: '/admin/billing',       icon: Receipt,                     label: 'Billing' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem('sidebarCollapsed') === '1'
  );

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);
  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', collapsed);
    localStorage.setItem('sidebarCollapsed', collapsed ? '1' : '0');
    return () => document.body.classList.remove('sidebar-collapsed');
  }, [collapsed]);

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className="wrapper">
      <div
        className={`sidebar-backdrop${sidebarOpen ? ' is-open' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`sidebar${sidebarOpen ? ' is-open' : ''}${collapsed ? ' is-collapsed' : ''}`} data-color="black">
        <div className="sidebar-wrapper">
          <div className="logo">
            <span className="simple-text">
              {collapsed
                ? <span style={{color:'var(--accent)'}}>CT</span>
                : <>Copy<span style={{color:'var(--accent)'}}>Trade</span></>}
            </span>
            <div className="logo-sub" style={{
              fontSize: 11, color: 'var(--text-tertiary)',
              textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 4,
            }}>Admin Console</div>
          </div>
          <ul className="nav">
            {NAV.map(n => (
              <li key={n.to}>
                <NavLink to={n.to} end={n.end || false} title={collapsed ? n.label : undefined}>
                  <n.icon size={16} strokeWidth={2} />
                  <p>{n.label}</p>
                </NavLink>
              </li>
            ))}
          </ul>
          <button
            className="sidebar-collapse-btn"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            onClick={() => setCollapsed(c => !c)}
          >
            {collapsed ? <ChevronsRight size={16} /> : <><ChevronsLeft size={16} /><span>Collapse</span></>}
          </button>
        </div>
      </div>

      <div className="main-panel">
        <nav className="navbar navbar-expand-lg navbar-absolute">
          <div className="container-fluid">
            <div className="navbar-wrapper" style={{display:'flex',alignItems:'center',gap:10}}>
              <button
                className="sidebar-toggle"
                aria-label="Toggle navigation"
                onClick={() => setSidebarOpen(o => !o)}
              >
                <Menu size={18} />
              </button>
              <div className="navbar-brand">CopyTrade</div>
            </div>
            <div className="navbar-nav ml-auto" style={{display:'flex',alignItems:'center',gap:12}}>
              <LiveDot />
              <NotificationBell />
              <div style={{
                display:'inline-flex', alignItems:'center', gap:8,
                padding:'6px 12px', borderRadius:'999px',
                background:'var(--bg-surface-2)', border:'1px solid var(--border-subtle)',
              }}>
                <UserCircle2 size={16} color="var(--text-secondary)" />
                <span className="user-email" style={{fontSize:12.5, color:'var(--text-primary)'}}>{user?.username || user?.email}</span>
              </div>
              <button className="btn btn-sm btn-secondary" onClick={handleLogout}
                style={{display:'inline-flex', alignItems:'center', gap:6}}>
                <LogOut size={14} /> Logout
              </button>
            </div>
          </div>
        </nav>

        <div className="content" style={{padding: '88px 24px 24px'}}>
          <Routes>
            <Route path="/"              element={<Overview />} />
            <Route path="/users"         element={<Users />} />
            <Route path="/containers"    element={<Containers />} />
            <Route path="/errors"        element={<Errors />} />
            <Route path="/relationships" element={<CopyRelationships />} />
            <Route path="/partners"      element={<Partners />} />
            {/* PROFIT-SHARE BILLING — TEMPORARILY DISABLED (2026-08-19) */}
            {/* <Route path="/billing"       element={<AdminBilling />} /> */}
          </Routes>
        </div>
      </div>
    </div>
  );
}
